import MUISkeleton, { SkeletonProps } from '@mui/material/Skeleton';
import { COLORS } from '../../theme';

const defaultStyles = { bgcolor: COLORS.gray[600] };

export default function Skeleton({
  variant = 'rectangular',
  animation = 'wave',
  sx,
  ...props
}: SkeletonProps) {
  const getStyles = () => {
    if (variant === 'circular') {
      return { ...defaultStyles, borderRadius: '50%', ...sx };
    }
    if (variant === 'rectangular') {
      return { ...defaultStyles, borderRadius: '8px', ...sx };
    }
    if (variant === 'rounded') {
      return { ...defaultStyles, borderRadius: '12px', ...sx };
    }
    return { ...defaultStyles, ...sx };
  };

  return <MUISkeleton variant={variant} animation={animation} sx={getStyles()} {...props} />;
}
